import createStore from './store/createStore'
import { browserHistory } from 'react-router'
import { changeLoading, snackAction, logout } from './routes/Main/modules/main'
import { serverUrl, apiUrl } from '../config/react'
import request from "./utils/request"

function createSignedRequest(key, type) {
  return request("POST", "/doctors/upload-avatar", { key, type })
    .then(response => response.json())
}

function uploadAvatarToStorage(file, signed_request, type) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open('PUT', signed_request)
    xhr.setRequestHeader('x-amz-acl', 'public-read')
    xhr.setRequestHeader('Content-Type', type)
    xhr.onload = function() {
      if (xhr.status === 200) {
        return resolve(true)
      }
      reject(false)
    }
    xhr.onerror = function() {
      reject(false)
    }
    xhr.send(file)
  })
}

function addTimeStamp(name) {
  let date = Date.now()
  let temp = name.split('.')
  for (let i = 0; i < temp.length - 1; i++) {
    name = temp[i] + '.'
  }
  name = name + date + '.' + temp[temp.length - 1]
  return name
}

export const api = {
  uploadFile: function(file) {
    return new Promise((resolve, reject) => {
      createStore.dispatch(changeLoading(true))
      if (!file) {
        return reject(false)
      }
      let key = file.name
      key = addTimeStamp(key)
      // if(key.lastIndexOf(".")){
      // 	key= key.slice(key.lastIndexOf("."));
      // }
      var type = file.type
      // key = name ? key+ name+ Number(new Date()).toString() : key+Number(new Date()).toString() ;

      createSignedRequest(key, type)
        .then(
          data => {
            uploadAvatarToStorage(file, data.signed_request, type).then(
              data2 => {
                createStore.dispatch(changeLoading(false))
                resolve(data.url)
              },
              err => {
                createStore.dispatch(changeLoading(false))
                reject(false)
              }
            )
          },
          err => {
            createStore.dispatch(changeLoading(false))
            reject(false)
          }
        )
        .catch(xxx => {
          createStore.dispatch(changeLoading(false))
          reject(false)
        })
    })
  },
  call: function(method, route, data, setLoading, snack) {
    return new Promise((resolve, reject) => {
      var req = new XMLHttpRequest()
      req.onreadystatechange = function() {
        if (req.readyState == 4) {
          if (req.status < 200 || req.status > 299) {
            reject()
            return createStore.dispatch(logout())
          }
          if (req.status == 200) {
            try {
              var response = JSON.parse(req.responseText)
              resolve(response)
            } catch (err) {
              resolve(req.responseText)
            }
          } else if (req.status != 0) {
            var response = JSON.parse(req.responseText)
            reject(response)
          }
          if (!setLoading) {
            createStore.dispatch(changeLoading(false))
          }
          if (req.status > 200) {
            // if (!!response.error) {
            let snack = {
              message: 'An error occur!',
              open: true
            }
            createStore.dispatch(snackAction(snack))
            setTimeout(function() {
              createStore.dispatch(snackAction({ open: false, message: '' }))
              browserHistory.push('/')
            }, 1000)
          }
          // if(snack && snack.message && snack.open){
          // 	createStore.dispatch(snackAction(snack));
          // 	setTimeout(function(){
          // 		createStore.dispatch(snackAction({open : false,message : ""}));
          // 	}, 3000);
          // }
        }
      }
      var url = route
      if (!url.startsWith('http')) {
        url = serverUrl + apiUrl + url
      }
      req.open(method || 'GET', url)
      var token = localStorage.getItem('access_token')
      if (typeof token === 'string') {
        req.setRequestHeader('Authorization', 'Basic ' + token)
      }
      var hasOpen = false
      req.setRequestHeader('media-type', 'application/json')
      req.setRequestHeader('cache-control', 'no-cache')
      try {
        if (typeof data === 'object') {
          req.setRequestHeader('Content-Type', 'application/json')
          req.send(JSON.stringify(data))
          hasOpen = true
        }
      } catch (e) {
        console.log(e) // TO SOLVE
      }
      if (!hasOpen) {
        req.send()
      }
      if (!setLoading) {
        createStore.dispatch(changeLoading(true))
      }
    })
  },
  get: function(route, data, setLoading, snack) {
    return this.call(
      'GET',
      route,
      data,
      setLoading ? setLoading : null,
      snack ? snack : null
    )
  },
  post: function(route, data, setLoading, snack) {
    return this.call(
      'POST',
      route,
      data,
      setLoading ? setLoading : null,
      snack ? snack : null
    )
  },
  put: function(route, data, setLoading, snack) {
    return this.call(
      'PUT',
      route,
      data,
      setLoading ? setLoading : null,
      snack ? snack : null
    )
  },
  delete: function(route, data, setLoading, snack) {
    return this.call(
      'DELETE',
      route,
      data,
      setLoading ? setLoading : null,
      snack ? snack : null
    )
  },
  postFile: function(route, data, setLoading, snack) {
    return this.call(
      'POST',
      route,
      data,
      setLoading ? setLoading : null,
      snack ? snack : null
    )
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api.js